import React from "react";
import classNames from "classnames";
import { StoryblokFullWidthInfoSection } from "../../../interfaces/Storyblok/StoryblokFullWidthInfoSection.interface";
import Crumb from "../../atoms/Crumb/Crumb.atom";

const FullWidthInfoSection: React.FC<StoryblokFullWidthInfoSection> = ({
  crumb,
  title,
  description,
  use_brand_background,
}) => {
  return (
    <section className={classNames({ "bg-Primary-50": use_brand_background })}>
      <div className="container mx-auto py-12 md:py-16">
        {crumb &&
          (use_brand_background ? (
            <p className="mb-3 text-sm font-bold uppercase tracking-wide text-Primary-500">{crumb}</p>
          ) : (
            <Crumb label={crumb} className="mb-6" />
          ))}

        {title && <h2 className="text-2xl font-extrabold leading-tight text-Body md:text-3xl">{title}</h2>}

        {description && (
          <p className="mt-6 text-xl font-semibold leading-relaxed text-Primary-900 whitespace-pre-line">
            {description}
          </p>
        )}
      </div>
    </section>
  );
};

export default FullWidthInfoSection;
